import { t } from "../../lib/i18n";
import { Badge } from "../ui/Badge";

export type ConnectivityState = "online" | "offline" | "never" | "unknown";

export function connectivityState(
  lastSeenAt: string | null | undefined,
  now: number,
  reportedOnline?: boolean,
): ConnectivityState {
  if (typeof reportedOnline === "boolean") return reportedOnline ? "online" : "offline";
  if (lastSeenAt === undefined) return "unknown";
  if (lastSeenAt === null) return "never";
  const age = now - Date.parse(lastSeenAt);
  if (!Number.isFinite(age) || age < -60_000) return "unknown";
  // Matches the documented admin heartbeat bucket; workplace presence is unrelated.
  return age < 300_000 ? "online" : "offline";
}

export function ConnectivityBadge({
  lastSeenAt, now, isOnline,
}: {
  lastSeenAt?: string | null;
  now: number;
  isOnline?: boolean;
}) {
  const state = connectivityState(lastSeenAt, now, isOnline);
  return (
    <Badge tone={state === "online" ? "success" : "neutral"}>
      {t(`operations.connectivity.${state}`)}
    </Badge>
  );
}
